export default {"src":"/_next/static/media/IncoFloat_icon.01c78e50.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};